module.exports = __webpack_public_path__ + "static/media/InRNG.57130ed2.svg";